import { render, staticRenderFns } from "./AddDiscountDropshipperModal.vue?vue&type=template&id=5399ea16&scoped=true"
import script from "./AddDiscountDropshipperModal.vue?vue&type=script&lang=js"
export * from "./AddDiscountDropshipperModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5399ea16",
  null
  
)

export default component.exports